module.exports = __webpack_public_path__ + "img/rice_snap.56b49c78.png";